import React from "react";
import Page from "components/common/page/Page.component";
import GlobalEnviromentContainer from "containers/enviroment/global/GlobalEnviroment.container";

const GlobalEnvironmentPage = () => {
    return (
        <Page title="Globale - Dati punti di monitoraggio">
            <GlobalEnviromentContainer />
        </Page>

    );
};

export default GlobalEnvironmentPage;
